export class UserExpiredException extends Error {
  code = "auth/expired";
  message = "บัญชีของคุณหมดอายุ";
}

export class UserSignInExpiredException extends Error {
  code = "auth/sign-in-expired";
  message = "บัญชีของคุณหมดอายุ";
}
